import { defineComponent, computed, onMounted } from "vue";
import { storeToRefs } from "pinia";
import { useMaintenanceScheduleStore } from "./maintenanceScheduleStore";
import Questions from "./questions";
import FormQuestionComponent from "./maintenanceScheduleFormQuestion.vue";
import MaintenanceScheduleYears from "./formQuestions/maintenanceScheduleYears.vue";
import MaintenanceScheduleModel from "./formQuestions/maintenanceScheduleModel.vue";
import MaintenanceScheduleTrim from "./formQuestions/maintenanceScheduleTrim.vue";
import MaintenanceScheduleMileage from "./formQuestions/maintenanceScheduleMileage.vue";
import maintenanceScheduleResults from "./maintenanceScheduleResults.vue";
export default defineComponent({
    name: "MaintenanceSchedule",
    components: {
        FormQuestionComponent,
        MaintenanceScheduleYears,
        MaintenanceScheduleModel,
        MaintenanceScheduleTrim,
        MaintenanceScheduleMileage,
        maintenanceScheduleResults, // eslint-disable-line
    },
    setup() {
        const yearQuestion = Questions.year;
        const modelQuestion = Questions.model;
        const trimQuestion = Questions.trim;
        const mileageQuestion = Questions.mileage;
        const store = useMaintenanceScheduleStore();
        const { questionYearAnswer, questionModelAnswers, questionModelAnswer, questionTrimAnswers, questionTrimAnswer, maintenanceScheduleNormal, maintenanceScheduleSevere, } = storeToRefs(store);
        onMounted(() => {
            displayPageStaticContent();
            store.getYears();
        });
        function displayPageStaticContent() {
            const amenitiesBlock = document.querySelector(".subaru-maintenance-schedule__page-content");
            amenitiesBlock.classList.add("show");
        }
        const enableModel = computed(() => {
            return (questionYearAnswer.value !== undefined &&
                questionModelAnswers.value !== undefined);
        });
        const enableTrim = computed(() => {
            return (questionModelAnswer.value !== undefined &&
                questionTrimAnswers.value !== undefined);
        });
        const enableMileage = computed(() => {
            return (questionTrimAnswers.value !== undefined &&
                questionTrimAnswer.value !== undefined);
        });
        const displayMaintenanceScheduleResults = computed(() => maintenanceScheduleNormal.value !== undefined &&
            maintenanceScheduleSevere.value !== undefined);
        return {
            enableModel,
            enableTrim,
            enableMileage,
            displayMaintenanceScheduleResults,
            yearQuestion,
            modelQuestion,
            trimQuestion,
            mileageQuestion,
        };
    },
});
